<template>
    <div>
        <v-simple-table class="table-layout pa-3">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Nhân viên</th>
                        <th>Số contact</th>
                        <th>Số đơn</th>
                        <th>Tỷ lệ chốt khởi tạo</th>
                        <th>DT khởi tạo</th>
                        <th>DT thành công</th>
                    </tr>
                </thead>
                <tbody v-if="marketerReports.length">
                    <tr>   
                        <td class="total-text">Tổng</td>
                        <td class="total-text">{{ formatPrice(total.numberOfContacts) }}</td>
                        <td class="total-text">{{ formatPrice(total.numberOfOrders) }}</td>
                        <td class="total-text">{{ total.initLatch + '%' }}</td>
                        <td class="total-text">{{ formatPrice(total.initTurnOver) }}</td>
                        <td class="total-text">{{ formatPrice(total.successTurnOver) }}</td>
                    </tr>
                    <template v-for="report in marketerReports">
                        <tr
                            :key="report.id"
                        >
                            <td>{{ report.fullName }}</td>
                            <td>{{ formatPrice(report.numberOfContacts) }}</td>
                            <td>{{ formatPrice(report.numberOfOrders) }}</td>
                            <td>{{ report.initLatch + '%' }}</td>
                            <td>{{ formatPrice(report.initTurnOver) }}</td>
                            <td>{{ formatPrice(report.successTurnOver) }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-if="!marketerReports.length">
                    <tr>
                        <td colspan="1000">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        marketerReports: {
            type: Array,
            default: () => {[]}
        },
        total: {
            type: Object,
            default: () => {}
        },
    },
}
</script>

<style scoped>
/deep/ .table-layout tbody tr {
    height: 48px !important
}

.total-text {
  color: #ff5252;
  font-size: 16px;
}
</style>